<template>
  <div>
    <h2 :class="['headline', 'font-grey', 'font-l-600']" v-html="title" />
    <div :class="['server-side-description']" v-html="description" />
    <example-title src="example-1.html" title="Timeline demo" />
    <div :class="['align-right', 'px-8']">
      <vc-switcher color="indigo" v-model="reverse" name="reverse">reversed timeline</vc-switcher>
    </div>
    <vc-timeline :reverse="reverse" @story="onStory($event)" :data="timeline" />
    <example-title src="example-1.html" title="Timeline :data example" />
    <p>The <code>:data</code> property of VcTimeline is an array, containing stories. Click the "view code" button
    about to see a typical <code>:data</code> property that can be used with the component.</p>
    <api-grid ref="api-grid" />
  </div>
</template>
<script>
import methods from '../helpers/methods'

export default {
  name: 'TimelinePage',
  mixins: [
    methods
  ],
  data () {
    return {
      title: null,
      description: null,
      reverse: false,
      timeline: [{
        breakpoint: '2002',
        history: [{
          date: 'June 21',
          color: 'teal',
          story: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.',
          title: 'Dolor Sit Amet',
          importance: 1
        }, {
          date: 'June 27',
          color: 'teal',
          story: 'Sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Duis aute irure dolor deserunt mollit anim id est laborum.',
          title: 'Consequuntur Magni',
          importance: 2
        }, {
          date: 'August 8',
          color: 'teal',
          story: 'Sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Duis aute irure dolor deserunt mollit anim id est laborum.',
          title: 'Sequi Nesciunt',
          importance: 2
        }, {
          date: 'December 8',
          color: 'teal',
          story: 'Sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Duis aute irure dolor deserunt mollit anim id est laborum.',
          title: 'Dolores Eos',
          importance: 2
        }]
      }, {
        breakpoint: '2004',
        history: [{
          date: 'March 8',
          story: 'Neque porro dolorem eum fugiat quo voluptas nulla pariatur? Consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.',
          icon: 'date_range',
          title: 'Voluptas nulla pariatur',
          importance: 1
        }, {
          date: 'April 13',
          story: 'Sed quia consequuntur magni dolores eos qui ratione voluptatem. Neque porro dolorem eum fugiat quo voluptas nulla pariatur? Consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.',
          icon: 'account_circle',
          title: 'Neque Porro',
          importance: 1
        }]
      }, {
        breakpoint: '2009',
        history: [{
          date: 'May 24',
          color: 'deep-purple',
          story: 'Temporibus aut perferendis doloribus asperiores repellat. Dolores eos qui ratione voluptatem. Neque porro dolorem',
          icon: 'assessment',
          title: 'Asperiores Repellat',
          importance: 1
        }, {
          date: 'June 7',
          color: 'orange',
          story: 'At vero eos quo minus id quod maxime placeat facere possimus, omnis voluptas.',
          icon: 'android',
          title: 'Facere Possimus, Omnis Voluptas',
          importance: 1
        }]
      }, {
        breakpoint: '2010',
        history: [{
          date: 'January 1',
          color: 'pink',
          story: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.',
          icon: 'home',
          title: 'Sit Amet',
          importance: 1
        }, {
          date: 'February 28',
          color: 'pink',
          story: 'Sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
          icon: 'bug_report',
          title: 'Ratione Voluptatem',
          importance: 2
        }]
      }, {
        breakpoint: '2018',
        history: [{
          date: 'October 15',
          color: 'red',
          story: 'At vero eos quo minus id quod maxime placeat facere possimus, omnis voluptas. Ratione voluptatem sequi nesciunt. Lorem ipsum dolor.',
          icon: 'cloud',
          title: 'Placeat Facere Possimus',
          importance: 2
        }, {
          date: 'November 5',
          color: 'orange',
          story: 'Temporibus aut perferendis doloribus asperiores repellat. Dolores eos qui ratione voluptatem. Neque porro dolorem',
          icon: 'dashboard',
          title: 'Doloribus Asperiores',
          importance: 1
        }]
      }]
    }
  },
  mounted () {
    this.getPage()
  },
  methods: {
    onStory (data) {
      console.log('vc-timeline:story', data)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/timeline.vue